import {
  Component,
  OnInit,
  Inject,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  SimpleChanges,
  Renderer2,
  NgZone,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatTooltip } from "@angular/material/tooltip";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
} from "@angular/material/dialog";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from "rxjs/operators";
import { City } from "src/app/core/interfaces/city";
import { AddressCargo } from "src/app/core/models/address-cargo.model";
import { Titles } from "src/app/core/resources/titles";
import { CatalogService } from "src/app/core/services/catalog.service";
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { ManualCreationCargoService } from "src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service";
import PlaceResult = google.maps.places.PlaceResult;
import { ModalEnum } from "src/app/core/enums/modal.enum";
import { ModalSelectionMapComponent } from "../modal-selection-map/modal-selection-map.component";
import { OptionsAutocomplete } from "src/app/core/interfaces/optionsAutocomplete";
import { Utils } from "src/app/core/resources/utils";

declare var google: any;

@Component({
  selector: "app-autocomplete-address",
  templateUrl: "./autocomplete-address.component.html",
  styleUrls: ["./autocomplete-address.component.scss"]
})
export class AutocompleteAddressComponent implements OnInit {
  // Inputs
  @Input() options: OptionsAutocomplete = {};
  @Input() inputFormControl: FormControl;
  @Input() validate: string;
  // Properties
  formControlAddress: FormControl = new FormControl();
  autocompleteInstance: any;

  @ViewChild("inputAutocomplete") inputAutocomplete: ElementRef;
  showCorrectAddress: boolean = false;
  newAddressSelected: FormControl = new FormControl();
  newAddressSub: Subscription;


  constructor(
    private snackBarService: SnackBarService,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    public utils: Utils
  ) { }

  ngOnInit() {
    if (!!this.options.disabled) {
      this.options.disabled
        .subscribe((disabled: boolean) => { disabled ? this.formControlAddress.disable() : this.formControlAddress.enable() });
    }
    const validator = this.inputFormControl && this.inputFormControl.validator ? this.inputFormControl.validator({} as AbstractControl) : '';
    if (validator && validator.required) this.formControlAddress.setValidators(Validators.required);
    this.newAddressSelected.updateValueAndValidity();
    // Ignorar las advertencias relacionadas con Autocomplete, hay que manejarlas antes del 1 de Marzo de 2026 y migrar a PlaceAutocompleteElement!!
    if (typeof console !== "undefined" && console.warn) {
      const originalWarn = console.warn;
      console.warn = function () {
        if (arguments[0] && arguments[0].includes('google.maps.places.Autocomplete')) return;
        if (arguments[0] && arguments[0].includes("Violation")) return;
        originalWarn.apply(console, arguments);
      };
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.options && changes.options.currentValue && changes.options.currentValue) {
        if (changes.options.previousValue && changes.options.currentValue.internationalCode !== changes.options.previousValue.internationalCode)
          this.initAutocompleteAddress();
        if (changes.options.currentValue.initialValue || changes.options.currentValue.initialValue === "")
          this.formControlAddress.setValue(changes.options.currentValue.initialValue);
      }
      if (changes.validate) {
        switch (this.validate) {
          case 'touched':
            this.formControlAddress.markAsTouched();
            break;
          case 'untouched':
            this.formControlAddress.markAsUntouched();
            break;
          case 'enable':
            this.formControlAddress.enable();
            break;
          case 'disable':
            this.formControlAddress.disable();
            break;
          case 'disable&untouched':
            this.formControlAddress.markAsUntouched();
            this.formControlAddress.disable();
            break;
          case 'setValidators':
            this.formControlAddress.setValidators(Validators.required);
            this.formControlAddress.updateValueAndValidity();
            break;
          case 'clearValidators':
            this.formControlAddress.clearValidators();
            this.formControlAddress.updateValueAndValidity();
            break;
          default:
            break;
        }
      }
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.markForCheck();
    if (!this.autocompleteInstance) this.initAutocompleteAddress();
  }

  initAutocompleteAddress() {
    setTimeout(() => {
      this.autocompleteInstance = new google.maps.places.Autocomplete(
        this.inputAutocomplete.nativeElement,
        {
          componentRestrictions: { country: this.options && this.options.internationalCode ? this.options.internationalCode.toLowerCase() : "co" },
        }
      );
      this.autocompleteInstance.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place = this.autocompleteInstance.getPlace();
          console.log('[AutocompleteAddress] place_changed place:', place);
          // La validación de que la dirección pertenece al municipio
          // seleccionado la hace el AsyncValidator del backend (polígono DANE)
          // sobre la lat/lng final. Aquí solo capturamos la selección.
          const address = this.inputAutocomplete.nativeElement.value;
          console.log('[AutocompleteAddress] setting formControlAddress to:', address);
          this.formControlAddress.setValue(address);
          const locationAddress = {
            lat: place && place.geometry && place.geometry.location && place.geometry.location.lat() ? place.geometry.location.lat() : null,
            lng: place && place.geometry && place.geometry.location && place.geometry.location.lng() ? place.geometry.location.lng() : null,
          };
          this.newAddressSelected.setValue(address);
          const data = { location: locationAddress, address };
          this.sendAddressData(data);
        });
      });
    }, 1000);
  }

  sendAddressData(data: { location: { lat: number, lng: number }, address: string }) {
    if (this.inputFormControl) this.inputFormControl.setValue(data);
  }

  selectAddressOnMap() {
    console.log('[AutocompleteAddress] selectAddressOnMap clicked. options =', this.options);
    this.snackBarService.openSnackBar('Selecciona una ubicación en el mapa', undefined, 'info');
    if (this.options && this.options.selectFromExternalMap) {
      this.inputFormControl.setValue({ selectFromMap: true })
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      clickMap: true
    };
    // Pipe del municipio (si el caller lo configuró) para que la modal pinte el
    // polígono DIVIPOLA y valide inline antes de cerrar.
    if (this.options && this.options.municipalityCode) {
      dialogConfig.data.municipalityCode = this.options.municipalityCode;
      console.log('[AutocompleteAddress] municipalityCode passed to modal:', this.options.municipalityCode);
    } else {
      console.warn('[AutocompleteAddress] NO municipalityCode in options — modal opens without polygon. options =', this.options);
    }
    const inputAddress = this.utils.getNestedValue(this.inputFormControl.value, 'address');
    const inputLocation = this.utils.getNestedValue(this.inputFormControl.value, 'location');
    if (inputAddress && inputLocation && inputLocation.lat && inputLocation.lng)
      dialogConfig.data.initialValue = { address: inputAddress, location: inputLocation };
    dialogConfig.height = ModalEnum.FORMS_HEIGHT;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ModalSelectionMapComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.state && result.data) {
        this.showCorrectAddress = false;
        this.formControlAddress.setValue(result.data.address);
        this.inputFormControl.setValue(result.data);
      }
    });
  }

  deleteAddress() {
    this.inputFormControl.setValue({ delete: true })
  }

  changeInput() {
    if (this.inputFormControl) this.inputFormControl.setValue("");
  }

  openAddressCorrection() {
    this.showCorrectAddress = true;
    this.newAddressSelected.setValue(this.formControlAddress.value);
    this.formControlAddress.disable();
  }

  addressCorrection(save: boolean) {
    if (!save) {
      this.showCorrectAddress = false;
      this.formControlAddress.enable();
      return;
    }
    if (this.newAddressSelected.value.trim() === "")
      return this.snackBarService.openSnackBar('Debes ingresar una dirección', undefined, 'alert');
    this.showCorrectAddress = false;
    let data = {
      location: this.inputFormControl.value.location,
      address: this.newAddressSelected.value.trim(),
    }
    this.sendAddressData(data);
    this.formControlAddress.enable();
    this.formControlAddress.setValue(this.newAddressSelected.value.trim());
  }

  ngOnDestroy() {
    this.cdRef.detach();
    if (this.newAddressSub) this.newAddressSub;
  }
}
